import { Component, input } from '@angular/core';
import { UserAvatarFileDto } from '@workspace/data-types';
import { AvatarAuraComponent } from '../../../media';

@Component({
  selector: 'aura-person-avatar-display',
  templateUrl: './person-avatar-display.component.html',
  imports: [AvatarAuraComponent],
})
export class AuraPersonAvatarDisplayComponent {
  currentAvatar = input<UserAvatarFileDto | undefined>(undefined);
  placeholder = input.required<string>();
}
